/*eslint-disable*/
import { ConfigProvider } from 'antd';
import 'antd/dist/antd.less';
import { useEffect, useState } from 'react';
import { hot } from 'react-hot-loader/root';
import { Provider, useSelector } from 'react-redux';
import { Redirect, Route, BrowserRouter as Router, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import ProtectedRoute from './components/utilities/protectedRoute';
import config from './config/config';
import GlobalPaletteStyles from './config/theme/GlobalPaletteStyles';
import GlobalTypographyStyles from './config/theme/GlobalTypographyStyles';
import GlobalScrollbars from './config/theme/GlobalScrollbars';
import LiveAgentCallModal from './container/dashboard/index/LiveAgentCallModal';
import { useAppDataContext } from './hooks/useAppDataContext';
import store from './redux/store';
import useSessionGuard from './hooks/useSessionGuard';
import Admin from './routes/admin';
import Auth from './routes/auth';
import './static/css/style.css';

const { theme } = config;

function GlobalCallModalWrapper() {
  const { activeApp, effectiveUser } = useAppDataContext(null);
  const currentAppId = activeApp?.app_id || effectiveUser?.app_id;

  if (!currentAppId) return null;

  return <LiveAgentCallModal appId={currentAppId} />;
}

function ProviderConfig() {
  const location = useLocation();
  // const { activeApp, effectiveUser } = useAppDataContext(null);
  const { rtl, isLoggedIn, topMenu, darkMode } = useSelector((state) => {
    return {
      darkMode: state.ChangeLayoutMode.data,
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
      isLoggedIn: state.auth.login,
    };
  });

  useSessionGuard(isLoggedIn?.user?.id);

  // const currentAppId = activeApp?.app_id || effectiveUser?.app_id;

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const packageId = queryParams.get('packageId');

    // Save packageId to sessionStorage if user isn't logged in
    if (!isLoggedIn && packageId) {
      sessionStorage.setItem('pendingPackageId', packageId);
    }
  }, [location.search, isLoggedIn]);

  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    let unmounted = false;
    if (!unmounted) {
      setPath(window.location.pathname);
    }
    return () => (unmounted = true);
  }, [setPath]);

  useEffect(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: '1295411105356879',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v20.0',
      });
    };

    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  }, []);

  return (
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
      <ThemeProvider theme={{ ...theme, rtl, topMenu, darkMode }}>
        <GlobalPaletteStyles />
        <GlobalTypographyStyles />
        <GlobalScrollbars />
        {isLoggedIn && <GlobalCallModalWrapper />}
        {!isLoggedIn ? <Route path="/" component={Auth} /> : <ProtectedRoute path="/admin" component={Admin} />}
        {isLoggedIn && (path === process.env.PUBLIC_URL || path === `${process.env.PUBLIC_URL}/`) && (
          <Redirect to="/admin" />
        )}
      </ThemeProvider>
    </ConfigProvider>
  );
}

function App() {
  return (
    <Provider store={store}>
      <Router basename={process.env.PUBLIC_URL}>
        <ProviderConfig />
      </Router>
    </Provider>
  );
}

export default hot(App);
